export const servicesData = [
  {
    id: 1,
    slug: 'bien-etre-vitalite-travail',
    title: 'Bien-être & vitalité au travail',
    icon: 'ri-briefcase-line',
    shortDescription: 'Programmes personnalisés pour améliorer la productivité et réduire le stress professionnel dans votre entreprise.',
    fullDescription: 'Notre programme de bien-être en entreprise aide vos équipes à maintenir un équilibre optimal entre vie professionnelle et santé mentale. Nous proposons des interventions sur site adaptées aux besoins spécifiques de votre organisation.',
    benefits: [
      'Réduction du stress et de l\'épuisement professionnel',
      'Amélioration de la concentration et de la productivité',
      'Renforcement de la cohésion d\'équipe',
      'Diminution de l\'absentéisme',
      'Création d\'un environnement de travail positif'
    ],
    process: [
      'Évaluation des besoins de l\'entreprise',
      'Conception d\'un programme personnalisé',
      'Sessions de groupe ou individuelles',
      'Suivi et ajustements réguliers'
    ],
    duration: '1h - 2h',
    price: 'Sur devis',
    image: 'https://public.readdy.ai/ai/img_res/46bbeddc775db6023db1531774f3245e.jpg'
  },
  {
    id: 2,
    slug: 'massotherapie-professionnelle',
    title: 'Massothérapie professionnelle',
    icon: 'ri-hand-heart-line',
    shortDescription: 'Massages thérapeutiques personnalisés pour soulager tensions musculaires et favoriser la détente profonde.',
    fullDescription: 'Nos massothérapeutes certifiés utilisent des techniques éprouvées pour traiter les douleurs chroniques, améliorer la circulation et restaurer l\'équilibre corporel. Chaque séance est adaptée à vos besoins spécifiques.',
    benefits: [
      'Soulagement des douleurs musculaires et articulaires',
      'Amélioration de la circulation sanguine',
      'Réduction du stress et de l\'anxiété',
      'Meilleure qualité de sommeil',
      'Renforcement du système immunitaire'
    ],
    process: [
      'Consultation initiale et évaluation',
      'Choix de la technique adaptée',
      'Séance de massage personnalisée',
      'Conseils post-massage'
    ],
    duration: '60 min - 90 min',
    price: 'À partir de 50 USD',
    image: 'https://readdy.ai/api/search-image?query=professional%20massage%20therapy%20session%20in%20luxury%20wellness%20spa%20with%20skilled%20therapist%20performing%20deep%20tissue%20massage%20on%20client%20lying%20on%20treatment%20table%2C%20serene%20peaceful%20atmosphere%20with%20soft%20ambient%20lighting%2C%20clean%20white%20linens%2C%20modern%20medical%20spa%20interior%20design%2C%20therapeutic%20healthcare%20setting%2C%20professional%20wellness%20treatment&width=800&height=600&seq=service2new&orientation=landscape'
  },
  {
    id: 3,
    slug: 'vr-massage-relaxation',
    title: 'VR Massage & relaxation profonde',
    icon: 'ri-vr-line',
    shortDescription: 'Expérience immersive unique combinant massage thérapeutique et réalité virtuelle pour une relaxation totale.',
    fullDescription: 'Technologie innovante exclusive en RDC : notre système VR Massage combine les bienfaits du massage traditionnel avec une immersion visuelle et sonore apaisante. Voyagez vers des destinations relaxantes pendant votre séance.',
    benefits: [
      'Relaxation profonde du corps et de l\'esprit',
      'Réduction significative du stress',
      'Expérience sensorielle complète',
      'Évasion mentale totale',
      'Technologie de pointe unique à Lubumbashi'
    ],
    process: [
      'Installation du casque VR',
      'Choix de l\'environnement virtuel',
      'Massage synchronisé avec l\'expérience',
      'Retour progressif à la réalité'
    ],
    duration: '45 min - 75 min',
    price: 'À partir de 75 USD',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20VR%20massage%20experience%20in%20high-tech%20wellness%20center%2C%20person%20wearing%20VR%20headset%20during%20massage%20therapy%2C%20modern%20medical%20technology%2C%20innovative%20healthcare%2C%20blue%20ambient%20lighting%2C%20clean%20minimalist%20design&width=800&height=600&seq=service3&orientation=landscape'
  },
  {
    id: 4,
    slug: 'maternity-zen',
    title: 'Maternity Zen',
    icon: 'ri-parent-line',
    shortDescription: 'Accompagnement complet pour femmes enceintes : massage prénatal, gymnastique douce et gestion du stress.',
    fullDescription: 'Programme spécialement conçu pour accompagner les futures mamans tout au long de leur grossesse. Nos spécialistes certifiés en périnatalité assurent votre confort et votre sécurité à chaque étape.',
    benefits: [
      'Soulagement des douleurs de grossesse',
      'Préparation physique à l\'accouchement',
      'Réduction du stress et de l\'anxiété',
      'Amélioration de la qualité du sommeil',
      'Connexion maman-bébé renforcée'
    ],
    process: [
      'Évaluation médicale préalable',
      'Massage prénatal adapté au trimestre',
      'Exercices de gymnastique douce',
      'Techniques de respiration et relaxation'
    ],
    duration: '60 min',
    price: 'À partir de 60 USD',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20prenatal%20massage%20for%20pregnant%20woman%20in%20soft%20pink%20wellness%20room%2C%20gentle%20therapeutic%20care%2C%20maternal%20health%2C%20serene%20atmosphere%2C%20professional%20medical%20spa%2C%20soft%20natural%20lighting%2C%20clean%20elegant%20environment&width=800&height=600&seq=service4&orientation=landscape'
  },
  {
    id: 5,
    slug: 'conseils-nutritionnels',
    title: 'Conseils nutritionnels & équilibrage alimentaire',
    icon: 'ri-restaurant-line',
    shortDescription: 'Plans nutritionnels personnalisés pour optimiser votre santé, énergie et vitalité au quotidien.',
    fullDescription: 'Nos nutritionnistes diplômés créent des programmes alimentaires adaptés à vos objectifs de santé, votre mode de vie et vos préférences culturelles. Approche holistique pour une transformation durable.',
    benefits: [
      'Amélioration de l\'énergie et de la vitalité',
      'Gestion du poids santé',
      'Renforcement du système immunitaire',
      'Prévention des maladies chroniques',
      'Éducation nutritionnelle personnalisée'
    ],
    process: [
      'Bilan nutritionnel complet',
      'Analyse des habitudes alimentaires',
      'Élaboration d\'un plan personnalisé',
      'Suivi régulier et ajustements'
    ],
    duration: '45 min',
    price: 'À partir de 40 USD',
    image: 'https://readdy.ai/api/search-image?query=nutritionist%20consultation%20with%20healthy%20fresh%20foods%20and%20meal%20planning%2C%20professional%20dietary%20advice%2C%20colorful%20fruits%20and%20vegetables%2C%20modern%20clinic%20setting%2C%20clean%20white%20background%2C%20health%20and%20wellness%20concept&width=800&height=600&seq=service5&orientation=landscape'
  },
  {
    id: 6,
    slug: 'soutien-psycho-emotionnel',
    title: 'Soutien psycho-émotionnel',
    icon: 'ri-mental-health-line',
    shortDescription: 'Accompagnement psychologique professionnel pour gérer stress, anxiété et défis émotionnels.',
    fullDescription: 'Nos psychologues cliniciens offrent un espace sécurisé et confidentiel pour explorer vos émotions, développer des stratégies d\'adaptation et retrouver votre équilibre mental.',
    benefits: [
      'Gestion du stress et de l\'anxiété',
      'Amélioration de l\'estime de soi',
      'Développement de la résilience émotionnelle',
      'Résolution de conflits intérieurs',
      'Accompagnement dans les transitions de vie'
    ],
    process: [
      'Première consultation d\'évaluation',
      'Définition des objectifs thérapeutiques',
      'Sessions de thérapie régulières',
      'Techniques de gestion émotionnelle'
    ],
    duration: '50 min',
    price: 'À partir de 45 USD',
    image: 'https://readdy.ai/api/search-image?query=compassionate%20psychological%20counseling%20session%20in%20calm%20modern%20therapy%20room%2C%20professional%20therapist%20and%20client%20in%20supportive%20conversation%2C%20peaceful%20atmosphere%2C%20soft%20natural%20light%2C%20mental%20health%20support%2C%20clean%20minimalist%20design&width=800&height=600&seq=service6&orientation=landscape'
  },
  {
    id: 7,
    slug: 'produits-naturels-vitalite',
    title: 'Produits naturels pour la vitalité',
    icon: 'ri-leaf-line',
    shortDescription: 'Sélection de produits naturels et compléments alimentaires pour booster votre énergie et immunité.',
    fullDescription: 'Gamme soigneusement sélectionnée de produits naturels, huiles essentielles et compléments alimentaires de qualité supérieure pour soutenir votre bien-être au quotidien.',
    benefits: [
      'Renforcement de l\'immunité naturelle',
      'Augmentation de l\'énergie vitale',
      'Amélioration de la qualité du sommeil',
      'Soutien de la santé digestive',
      'Produits certifiés et traçables'
    ],
    process: [
      'Consultation avec notre spécialiste',
      'Recommandations personnalisées',
      'Explication des modes d\'utilisation',
      'Suivi des résultats'
    ],
    duration: '30 min',
    price: 'Variable selon produits',
    image: 'https://readdy.ai/api/search-image?query=natural%20wellness%20products%20display%20with%20essential%20oils%20herbs%20and%20supplements%2C%20organic%20health%20products%2C%20botanical%20ingredients%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20wellness%20store%20aesthetic&width=800&height=600&seq=service7&orientation=landscape'
  },
  {
    id: 8,
    slug: 'gestion-du-poids-vitality-zen',
    title: 'Gestion du poids – VITALITY ZEN PROGRAM',
    icon: 'ri-heart-pulse-line',
    shortDescription: 'Programme médical complet pour perdre jusqu\'à 5 kg en 8 semaines avec accompagnement personnalisé et sécurisé.',
    fullDescription: 'Programme médical et bien-être complet pour femmes et hommes en surpoids, avec accompagnement personnalisé pour une perte de poids durable et sécurisée. Perdez jusqu\'à -5 kg en 8 semaines sans danger pour votre santé grâce à notre approche holistique combinant nutrition, sport et soins corporels.',
    benefits: [
      'Perte de poids progressive et durable (-5 kg en 8 semaines)',
      'Accompagnement médical et nutritionnel personnalisé',
      'Renforcement musculaire et tonification corporelle',
      'Amélioration du métabolisme et de l\'énergie',
      'Détoxification naturelle de l\'organisme',
      'Suivi hebdomadaire et ajustements personnalisés'
    ],
    process: [
      'Consultation nutritionniste et bilan de santé',
      'Élaboration du plan alimentaire personnalisé',
      'Coaching sportif avec Médecin & Coach sportive',
      'Séances plaque vibrante (3x/semaine, 15 min)',
      'Massages ventre plat & minceur (3 séances)',
      'Jus détox 100% naturel offert',
      'Suivi hebdomadaire pendant 8 semaines'
    ],
    duration: '8 semaines',
    price: 'Programme complet sur devis',
    image: 'https://static.readdy.ai/image/a0897f463ac1d23797a54fc0386c922a/923845169487ef37e9746b401198f1ae.jpeg',
    packageIncludes: [
      'Consultation nutritionniste personnalisée',
      'Équilibrage alimentaire sur mesure (besoins caloriques)',
      'Coaching sportif avec Médecin & Coach sportive',
      '3 massages ventre plat & minceur',
      '3 séances plaque vibrante / semaine (15 minutes)',
      'Massage ventre plat ciblé',
      'Jus détox 100% naturel offert',
      'Programme complet de 8 semaines'
    ]
  }
];

export const featuredServices = servicesData.slice(0, 6);